/* Routes that behave as campaign landing pages rather than site pages.
 *
 * They get the closing CTA banner and NOT the full "Explore Aura AI" sitemap:
 * someone arriving from an ad should be pushed toward one action, not handed
 * forty links out of the funnel.
 *
 * Shared because Footer.tsx and FooterEmailBanner.tsx both need the same
 * answer, and each keeping its own copy is how one ends up showing the banner
 * while the other still shows the sitemap.
 */
export const SEO_LANDING_ROUTES = [
  "/kundli-matching",
  "/free-kundli",
  "/ai-astrologer",
  "/daily-horoscope",
];

/** True on /market, /global and the SEO landing pages. */
export const isLandingRoute = (pathname: string) =>
  pathname === "/market" ||
  pathname === "/global" ||
  SEO_LANDING_ROUTES.includes(pathname);
